import { Selection, ActionButton, CommandButton, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, IColumn, IContextualMenuProps, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowProps, IRenderFunction, Label, Link, MessageBarType, ProgressIndicator, SelectionMode, Stack, Text, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventForTeachers } from '../../../Models/Event/IEventForTeachers';
import { IAttendeeRegistrationListItemForTeacher } from '../../../Models/Event/IEventForTeachersRegistrationItem';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IEventApi } from '../../../Services/API/Event/IEventApi';

import { EmailAddressExportPanel } from '../Users/EmailAddressExportPanel/EmailAddressExportPanel';

interface ITeacherAttendeeListProps {
    event?: IEventForTeachers;
}


export const TeacherAttendeeList: React.FunctionComponent<ITeacherAttendeeListProps> = (props) => {

    
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [selected, setSelected] = React.useState<IAttendeeRegistrationListItemForTeacher[]>([]);

    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as IAttendeeRegistrationListItemForTeacher[];
            setSelected(selected);
            console.log(selected);
        },
        selectionMode: SelectionMode.multiple
    }));



    const theme = useTheme();

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    
  


    React.useEffect(() => {
        buildColumns();

    }, [])


    const buildColumns = () => {
        const _columns: IColumn[] = [
            { key: 'firstName', name: 'Jméno', fieldName: 'firstName', minWidth: 60, maxWidth: 100, isResizable: true, styles: headerStyle, isCollapsible:true },
            { key: 'lastName', name: 'Příjmení', fieldName: 'lastName', minWidth: 60, maxWidth: 100, isResizable: true, styles: headerStyle },
            { key: 'ageOnStart', name: 'Věk', fieldName: 'ageOnStart', minWidth: 30, maxWidth: 30, isResizable: true, styles: headerStyle, isCollapsible: true },
            { key: 'doprovod', name: 'Doprovod', fieldName: 'doprovod', minWidth: 75, maxWidth: 130, isResizable: true, styles: headerStyle, isCollapsible: true },
            { key: 'email', name: 'Email', fieldName: 'email', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle, isCollapsible: true },
            { key: 'telefon', name: 'Telefon', fieldName: 'telefon', minWidth: 80, maxWidth: 120, isResizable: true, styles: headerStyle, isCollapsible: true },
        ];
        setColumns(_columns);
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
    //const onRenderRow: IRenderFunction<IDetailsRowProps> = (props: any, defaultRender: any) => {
    //    return (<div key={props.item.key} data-selection-toggle="false" data-selection-touch-invoke="false" data-selection-disabled={true}>
    //        <DetailsRow {...props}/>
    //    </div>)
    //}

    const renderItemColumn = (item: IAttendeeRegistrationListItemForTeacher, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof IAttendeeRegistrationListItemForTeacher];
            switch (column.key) {
                case "email":
                    return <Link title={fieldContent.toString()} href={"mailto:" + fieldContent}>{fieldContent}</Link>

                default:
                    return <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</div>;
            }
        }
        else {
            return (<div></div>)
        }
    }

    const prepareEmailAddresses = (): string[] => {

        return selected.map(item => item.email);
    }

    return (
        <Stack>
            <Stack styles={{ root: { height: 10 } }}>
                {isLoading ? <ProgressIndicator /> : null}
            </Stack>

            <Stack styles={{ root: { paddingLeft:5 } }} horizontal tokens={{ childrenGap: 10 }} verticalAlign="center">
                 <Label>Počet lekcí / pololetí </Label>
                <Text>{props.event?.numberOfLessons} x {props.event?.lessonLength} min.</Text>
            </Stack>
            <EmailAddressExportPanel emails={selected.map(item => {
                return { firstname: item.firstName, lastname: item.lastName, email: item.email }
            })} />

            {props.event ?
                <DetailsList
                    items={props.event?.registrations ? props.event?.registrations:[]}
                    columns={columns}
                    setKey="set"
                    onRenderDetailsHeader={onRenderDetailsHeader}
                    onRenderItemColumn={renderItemColumn}
                    selectionMode={SelectionMode.multiple}
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionPreservedOnEmptyClick={false}
                    ariaLabelForSelectionColumn="Výběr žáka"
                    ariaLabelForSelectAllCheckbox="Výběr žáka"
                    checkButtonAriaLabel="Vyber řádek"
                    selection={selectionState}
               
                     />
                : null}
    </Stack>
)
}
